import React from "react";
import styled from "styled-components";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getWallpaperBgColor } from "../../../utils/helpers";
import TextView from "../../TextView";
import { device } from "../../../utils/device";
import useScreenSize from "../../../hooks/useScreenSize";

// Styled Components
const ListContainer = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  top: 0;
  background-color: white;
  width: ${({ selectedArc }) => (selectedArc ? "80vw" : "94vw")};
  padding: 12px;
  border-radius: 8px;
  height: max-content;
  z-index: 100;
  scrollbar-width: 0px;

  @media (${device.mobileLandscape}) {
    position: relative;
    width: ${({ selectedArc }) => (selectedArc ? "35vw" : "50vw")};
    top: 0;
    margin-right: ${({ selectedArc }) => (selectedArc ? "20px" : "0px")};
  }

  ${({ isMobileLandscape }) =>
    isMobileLandscape &&
    `
      width: ${({ selectedArc }) => (selectedArc ? "35vw" : "50vw")};
      margin-right: ${({ selectedArc }) => (selectedArc ? "20px" : "0px")};
    `}
`;

const List = styled.div`
  max-height: ${({ selectedArc }) =>
    selectedArc ? "22svh" : `calc(100svh - 18svh - 3vw - 40px)`};
  display: flex;
  flex-direction: column;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  @media (${device.mobileLandscape}) {
    height: 76svh;
    max-height: 76svh;
  }
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid;
  justify-content: space-between;
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: 1fr auto;
  height: 40px;
  margin-right: 1px;
`;

const Header = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
`;

const Circle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 1rem;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const SegmentsList = ({
  wheelSegments,
  onClose,
  onClickLabel,
  selectedArc,
}) => {
  const { portraitScreenRatio, isMobilePortrait, isMobileLandscape } =
    useScreenSize();

  const onItemClick = (id) => {
    onClickLabel(id);
  };

  return (
    <ListContainer
      selectedArc={selectedArc}
      isMobileLandscape={isMobileLandscape}
    >
      <Header>
        <TextView variant="subtitle" style={{ fontWeight: 700 }}>
          <ArrowBackIcon style={{ marginRight: 5 }} onClick={onClose} />
          Back to wheel
        </TextView>
      </Header>
      <List
        isMobileLandscape={isMobileLandscape}
        selectedArc={selectedArc}
        style={{
          height:
            isMobilePortrait && selectedArc
              ? portraitScreenRatio >= 1.5
                ? "48vw"
                : "52vw"
              : undefined,
        }}
      >
        {wheelSegments.map((segment, index) => {
          const { title, id, color } = segment;
          return (
            <ListItem
              key={index}
              style={{
                backgroundColor: getWallpaperBgColor(color, 0.3),
                borderColor: color,
              }}
              onClick={() => onItemClick(id)}
            >
              <Row>
                <Circle style={{ backgroundColor: color }} />
                <TextView>{title}</TextView>
              </Row>
              <ChevronRightIcon style={{ alignSelf: "flex-end" }} />
            </ListItem>
          );
        })}
      </List>
    </ListContainer>
  );
};

export default SegmentsList;
